var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGrafik(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9801 37.1202C39.9801 39.2902 38.2201 41.0602 36.0401 41.0602C33.8601 41.0602 32.1001 39.3002 32.1001 37.1202C32.1001 34.9402 33.8601 33.1802 36.0401 33.1802C38.2201 33.1802 39.9801 34.9402 39.9801 37.1202Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 19C18.35 19 16 21.35 16 24.25V50.5C16 53.4 18.35 55.75 21.25 55.75H52.75C55.65 55.75 58 53.4 58 50.5V24.25C58 21.35 55.65 19 52.75 19H21.25ZM52.75 21.63C54.2 21.63 55.38 22.81 55.38 24.26V41.31L45.47 36.2C44.97 35.95 44.36 36.05 43.96 36.44L34.22 46.18L27.24 41.53C26.72 41.18 26.03 41.25 25.59 41.69L18.64 47.87V24.25C18.64 22.8 19.82 21.62 21.26 21.62H52.76L52.75 21.63Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGrafik);
export default __webpack_public_path__ + "static/media/icon_grafik.c4129a56bf84db1b329e13482cefb605.svg";
export { ForwardRef as ReactComponent };